import { Identifiers, SectionsKey } from "~/constants/enum";

const PageStruct = {
  id: "collection-detail",
  useLayout: true,
  children: [
    { id: SectionsKey.ProductList, order: 1, dataKey: SectionsKey.ProductList },
    {
      id: SectionsKey.CollectionsContent,
      order: 2,
      dataKey: SectionsKey.CollectionsContent,
    },
    // { id: SectionsKey.TabReviews, order: 3 },
    { id: SectionsKey.HomePageReviews, order: 3, dataKey: SectionsKey.HomePageReviews },
    // { id: SectionsKey.RecentlyView, order: 4 },
    { id: SectionsKey.BenefitsSection, order: 4, identifier: Identifiers.BenefitsSection },
    { id: SectionsKey.FollowUs, order: 5, identifier: Identifiers.FollowUs }
  ],
};

export default PageStruct;
